export default function (a, b) {
    a = +a;
    b -= a;
    return function (t) { return a + b * t; };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-charts-community/dist/es6/interpolate/number.js
// module id = null
// module chunks = 